<template>
  <!-- images for the first 6 (slidesPerView) slides -->
  <div class="speed image" v-on="$listeners" v-if="index < slidesPerView && categoryIndex === 0">
    <images :image="image" :alt="alt" :width="width" :height="height"/>
  </div>
  <!-- lazy loading of images after the first 6 (slidesPerView) slides -->
  <div class="lazy image" v-on="$listeners" v-else>
    <images-lazy-load :image="image" :alt="alt" :width="width" :height="height"/>
  </div>
</template>

<script>
import Images from "./Images";
import ImagesLazyLoad from "./ImagesLazyLoad";

export default {
  components: {
    Images,
    ImagesLazyLoad
  },
  props: {
    image: {
      type: Object,
      default: () => ({
        src: '',
        loading: ''
      })
    },
    alt: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 346
    },
    height: {
      type: Number,
      default: 346
    },
    index: {
      type: Number,
      default: 0
    },
    slidesPerView: {
      type: Number,
      default: 6
    },
    categoryIndex: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
  .image{
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    overflow: hidden;
    mix-blend-mode: multiply;
    &__thumb {
      max-width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      width: auto;
      height: auto;
      -webkit-transform: translate3d(-50%, -50%, 0);
      transform: translate3d(-50%, -50%, 0);
      pointer-events: none;
    }
  }
</style>
